import { useQuery, UseQueryResult } from "react-query";
import axios from "axios";
import Config from "../config/auth.json";
import { AdditionalConfig } from "../utils/consts";
import { useOktaAuth } from "@okta/okta-react";

export type Customer = {
  CustomerID: string;
  Name: string;
  Enabled: boolean;
};

const fetchCustomers = async (): Promise<Customer[]> => {
  const token = JSON.parse(window.localStorage.getItem("okta-token-storage") || "{}")?.accessToken?.accessToken;
  try {
    const response = await axios.get(`${Config.endpoint}contractsservice/customers`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data ?? [];
  } catch (error) {
    console.error("Error fetching customers:", error);
    return [];
  }
};

export const useGetCustomers = (isSubscribed = false): UseQueryResult<Customer[]> => {
  const { authState } = useOktaAuth();
  const token = authState?.accessToken?.accessToken;
  return useQuery(["customers"], fetchCustomers, {
    enabled: !!token && isSubscribed,
    ...AdditionalConfig,
  });
};
